const formatRouteForAAB = ({
  appointmentMenuItems,
  appointmentRoute,
  route,
  searchParams
}) => {
  return appointmentMenuItems.map((item) => {
    if (item?.link?.href?.startsWith(appointmentRoute)) {
      item.link.href = `${appointmentRoute}${route ? `/${route}` : ""}?${searchParams}`;
    }
    return item;
  });
};
export {
  formatRouteForAAB
};
//# sourceMappingURL=format-route-for-aab.js.map
